export default {
      id: "arrawUp-usage",
      viewBox: "0 0 8 7",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrawUp",
      toString: function () {
        return this.url;
      }
    }